import styled from "styled-components";

interface TextFieldProps {
	textAlign?: string;
	letterSpacing?: number;
	errorMode?: boolean;
}

//Esse componente sera utilizado para poder fazer todos os componentes de texto e que tem (ou não) mascara
const TextField = styled.input<TextFieldProps>`
	height: 50px;
	width: 100%;
	background: #ffffff;
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 165.5%;
	border: ${props => (props.errorMode ? "2px solid #ba6969" : "2px solid #d8dbe4")};
	padding-left: ${props => (props.textAlign === "left" || !props.textAlign ? "15" : "0")}px;
	border-radius: 8px;
	box-sizing: border-box;
	::placeholder {
		color: #959aab;
		font-size: 14px;
		font-weight: 500;
	}
	:focus {
		outline: none;
		border: ${props => (props.errorMode ? "2px solid #943737" : "2px solid 2px solid #a5a7ad")};
	}
	text-align: ${props => props.textAlign || "left"};
	${props => (props.letterSpacing ? "letter-spacing: " + props.letterSpacing + "em;" : "")};
`;

export default TextField;
